
import { Box, Grid, Typography, Dialog } from "@mui/material";
import React, { useState } from "react";
import RegistrationForm from "./Authentication/RegistrationForm";
import OTPScreen from "./Authentication/OTPScreen";
import PersonalDetailsForm from "./Authentication/PersonalDetailsForm";
import EducationJobForm from "./Authentication/EducationJobForm";
import FamilyDetailsForm from "./Authentication/FamilyDetailsForm";
import PartnerPrefrencesForm from "./Authentication/PartnerPrefrencesForm";
import { useNavigate } from "react-router-dom";
import image from '../homepage/image.png';
import "../styles/Header.css";
import HomeImageCarousel from "./userdashbord/homepageImageCourousels";
import { FontStyles } from "../styles/FontStyles";
function HeroSection() {
    const [currentStep, setCurrentStep] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState("");
    const navigate = useNavigate();

    const handleRegistration = (phone) => {
        setPhoneNumber(phone);
        setCurrentStep(1);
    };

    const handleOTPSubmit = () => {
        navigate("/profile/personal-details");
    };

    const handleContinue = () => {
        if (currentStep < 5) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handleBack = () => {
        setCurrentStep(0);
        return true;
    };

    const renderCurrentStep = () => {
        switch (currentStep) {
            case 0:
                return <RegistrationForm onRegister={handleRegistration} />;
            // case 1:
            //     return <OTPScreen phoneNumber={phoneNumber} onSubmit={handleOTPSubmit} onBack={handleBack} />;
            case 2:
                return <PersonalDetailsForm onContinue={handleContinue} />;
            case 3:
                return <EducationJobForm onContinue={handleContinue} />;
            case 4:
                return <FamilyDetailsForm onContinue={handleContinue} />;
            case 5:
                return <PartnerPrefrencesForm onContinue={handleContinue} />;
            default:
                return <RegistrationForm onRegister={handleRegistration} />;
        }
    };

    return (
        <Box sx={{ marginTop: "20px", backgroundColor: "rgba(245,234,217,255)" }}>
            <Grid
                container
                spacing={2}
                sx={{
                    width: "100%",
                    maxWidth: "1450px",
                    mx: "auto",
                    alignItems: "center",
                }}
            >
                {/* <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop:'100px'
                    }}
                > */}
                <HomeImageCarousel />
                {/* <img
                        src="/images/homeScreenImage2.png"
                        alt="Telugu Couple"
                        style={{
                            width: "100%",
                            height: "480px",
                            objectFit: "contain",
                            
                            // marginRight:{xs:"0",sm:"0%"},
                            // marginBottom:{xs:"0px"}
                        }}
                    /> */}


                {/* </Grid> */}

                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "500px",
                            textAlign: "center",
                        }}
                    >
                        <Box
                            component="img"
                            src={image}
                            alt="Background"
                            sx={{
                                width: { xs: "280px", sm: "350px", md: "400px", lg: "450px", xl: "500px" },
                                opacity: 0.2,
                                marginTop: { xs: '0px', sm: "20%" },
                                maxWidth: "100%",
                                marginRight: { xs: "10%" }
                            }}
                        />
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 1,
                                width: "90%",
                            }}
                        >
                            <Typography
                              sx={{...FontStyles. onlyTelugu}}
                            >
                                Only For Telugu People
                            </Typography>
                            <Typography
                                sx={{
                                 ...FontStyles. anywhre
                                }}
                            >
                                (Anywhere Across The World)
                            </Typography>
                            <Typography
                               sx={{...FontStyles.findyour}}
                            >
                                <br />
                                Find Your DREAM Life
                            </Typography>
                            <Typography
                                sx={{
                               ...FontStyles. partner
                                }}
                            >
                                Partner in Just 5 Min
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Dialog
                    open={currentStep === 1}
                    onClose={handleBack}
                    maxWidth="xs"
                    fullWidth
                >
                    <Box sx={{ padding: "20px" }}>
                        <OTPScreen
                            phoneNumber={phoneNumber}
                            onSubmit={handleOTPSubmit}
                            onBack={handleBack}
                        />
                    </Box>
                </Dialog>
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Box
                        className="form"
                        sx={{
                            backgroundColor: "white",
                            padding: { xs: "1rem", sm: "1.5rem" },
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            width: "100%",
                            alignItems: { xs: 'center' },
                            maxWidth: { xs: "100%", sm: "100%", md: "600px" },
                            marginTop: { xs: "0px", sm: "0", md: "30%" },
                            marginBottom: { xs: "20px" },
                            marginLeft: { xs: "0", sm: "0", xl: "15%" },
                            marginRight: { xs: '18px', sm: "50px" }
                        }}
                    >
                        {renderCurrentStep()}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default HeroSection;